module.exports = __webpack_public_path__ + "02cb7ebd16aae7d1f1ad21e80ce5bae4.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/500_l_50.mp3
// module id = 454
// module chunks = 0